<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Anna</h3>
<p class="vers">Solch schönes Gefäß, solch süßer Wein<br class="calibre2"/>
soll zerfallen und ungetrunken sein?</p>
<p class="vers">Ein Auge, so rein wie Sternenlicht,<br class="calibre2"/>
nicht soll es erleuchten und wärmen nicht?</p>
<p class="vers">Und irren doch rings in der Welt umher<br class="calibre2"/>
viel Seelen so licht- und so wärmeleer,</p>
<p class="vers">die sich sehnen so sehr nach der Liebe
Strahl,<br class="calibre2"/>
der sich nie durch die Nacht ihres Lebens stahl.</p>
<p class="vers">Solch süßer Leib, solch schwellende Brust<br class="calibre2"/>
soll nie erblühen in Liebeslust?</p>
<p class="vers">Solch wilde Kraft austoben nie<br class="calibre2"/>
als in kranken Phantomen der Phantasie?</p>
<p class="vers"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page22" title="wedi/Konmax"></a> Solch stolzer Bau auf ewig vergehn,<br class="calibre2"/>
nicht im Erben einmal wieder auferstehn?</p>
<p class="vers">Tauschönes Bild, ich sog deinen Duft,<br class="calibre2"/>
so leicht wie der gleitende Atem der Luft,</p>
<p class="vers">umgaukelte dich, ein Falter blau,<br class="calibre2"/>
doch strich ich dir ab kein Tröpflein Tau.</p>
<p class="vers">Du duftest und stehest noch taufrisch im
Hain,<br class="calibre2"/>
doch der Winter bricht mit den Frösten herein.</p>
<p class="vers">Der Frühtau gefriert, der Dufthauch erstirbt,<br class="calibre2"/>
und der Tod um die liebliche Blume wirbt.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?5d6b2b60